import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const location = useLocation();

  const navLinks = ['Home', 'Solutions', 'About', 'Contact'];

  const isActive = (path) =>
    location.pathname === (path === '/' ? '/' : `/${path.toLowerCase()}`);

  return (
   <motion.nav
  initial={{ y: -80, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 0.5, ease: 'easeOut' }}
  className="fixed top-0 w-full z-50 bg-[#0D1B2A]/40 backdrop-blur-none md:backdrop-blur-lg text-white shadow-md"
>
<div className="container mx-auto px-4 py-4 flex items-center justify-between">
  {/* Logo and Brand Name */}
<div className="flex items-center space-x-3">
  <div className="h-12 w-12 rounded-full overflow-hidden relative">
    <img
      src="/CM logo-2.png  "
      alt="CM Logo"
      className="absolute top-1/2 left-1/2 h-full w-full object-cover object-center transform -translate-x-1/2 -translate-y-1/2"
    />
  </div>
  <motion.h1
    className="text-base sm:text-lg font-bold tracking-tight text-white"
  >
    CmCoreTech
  </motion.h1>
</div>





        {/* Mobile Menu Toggle */}
        <motion.button
          className="md:hidden p-2 rounded hover:bg-blue-800 transition"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
          whileTap={{ scale: 0.95 }}
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </motion.button>

        {/* Desktop Links */}
        <ul className="hidden md:flex space-x-6 items-center">
          {navLinks.map((item) => {
            const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
            return (
              <motion.li
                key={item}
                whileHover={{ scale: 1.07 }}
                transition={{ type: 'spring', stiffness: 200 }}
                className="relative group"
              >
                <Link
                  to={path}
                  className={`transition duration-300 ${
                    isActive(path) ? 'text-blue-300' : 'hover:text-blue-300'
                  }`}
                >
                  {item}
                </Link>
                <span
                  className={`absolute left-0 -bottom-1 h-[2px] w-full bg-blue-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left ${
                    isActive(path) ? 'scale-x-100' : ''
                  }`}
                ></span>
              </motion.li>
            );
          })}
        </ul>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-blue-950/80 text-white px-4 py-4 backdrop-blur-lg shadow-md"
          >
            <ul className="flex flex-col space-y-4">
              {navLinks.map((item) => {
                const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
                return (
                  <motion.li
                    key={item}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                  >
                    <Link
                      to={path}
                      className={`block transition ${
                        isActive(path) ? 'text-blue-300' : 'hover:text-blue-300'
                      }`}
                      onClick={() => setIsOpen(false)}
                    >
                      {item}
                    </Link>
                  </motion.li>
                );
              })}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
